import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import LayerDto from 'home/dto/LayerDto'
import { setLayersIndex } from './mapTreatments/AddingLayers'
import { orderBy, isNumber } from 'lodash'
import { Card, Grid2, Stack } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import AccountAction from 'account/actions/AccountAction'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import { LAYERS_ORDER } from 'carto/constants/CartoConstants'
import moment from 'moment'
import VerticalSortableList from 'components/draggable/VerticalSortableList'
import { DragHandle, SortableItem } from 'components/draggable/components/sortableItems/SortableItem'

const CartographyOrderPanel = ({
    activeLayers = [],
}) => {
    const {
        accountUser,
        accountUserSettings,
    } = useSelector(store => ({
        accountUser: store.AccountReducer.accountUser,
        accountUserSettings: store.AccountReducer.accountUserSettings,
    }), shallowEqual)

    const ordersSetting = useAccountSetting(LAYERS_ORDER, s => JSON.parse(s || '{}')) || {}
    const [layers, setLayers] = useState(orderBy(activeLayers.map(l => ({ ...l, order: ordersSetting[l.layer] })), 'order', 'desc'))

    const dispatch = useDispatch()

    useEffect(() => {
        // the first item has to have the higher order for openlayer
        const reverseItems = layers.map((l, i) => ({ ...l, order: (i + 1) * -1 }))
        setLayersIndex(reverseItems)
        const newOrders = reverseItems.reduce((acc, l) => ({ ...acc, [l.layer]: l.order }), {})
        const filterSettings = accountUserSettings.filter(o => o.parameter !== LAYERS_ORDER)
        const newSettings = [ ...filterSettings, {
            login: accountUser.login,
            parameter: LAYERS_ORDER,
            updateDate: moment().valueOf(),
            value: JSON.stringify(newOrders) || '',
        }]
        dispatch(AccountAction.updateSettings(accountUser.login, newSettings, true, false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [layers])

    return (
        <Grid2 sx={{ '& svg:hover': { cursor: 'pointer' } }}>
            <Card>
                <CardTitle title={i18n.orderLayers} />
                <VerticalSortableList
                    items={layers}
                    onChange={setLayers}
                    renderItem={(layer, index) => (
                        <SortableItem id={layer.id}>
                            <Stack direction={'row'} spacing={1.5} alignItems='center'>
                                <DragHandle />
                                {isNumber(index) ? `${index + 1} - ` : ''}{layer.name}
                            </Stack>
                        </SortableItem>
                    )}
                />
            </Card>
        </Grid2>
    )
}

CartographyOrderPanel.propTypes = {
    activeLayers: PropTypes.arrayOf(PropTypes.instanceOf(LayerDto)),
}

export default CartographyOrderPanel